import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { List } from '../../models/list.model';
import { ConfigService } from 'src/app/core/services/config-service';
import { ApplicationMappingDto } from '../../models/dto/applicationMappingDto.model';

@Injectable()
export class ApplicationMappingService {
  constructor(private http: HttpClient) {}

  configService = inject(ConfigService);

  load(params: {
    page: number;
    pageSize: number;
    sort: string;
    sortDirection: string;
    filters: string[];
    applicationTypeId: number;
    env: string;
  }): Observable<List<ApplicationMappingDto>> {
    const url =
      this.configService.readConfig().baseUrlInfrastructure +
      `/application/GetApplicationMappingConfigWithPagination` +
      `?PageSize=${params.pageSize}` +
      `&PageNumber=${params.page}` +
      `&Sort=${params.sort}` +
      `&SortDirection=${params.sortDirection}` +
      `&Filter=${params.filters.join('&Filter=')}` +
      `&Env=${params.env}` +
      `&ApplicationTypeId=${params.applicationTypeId}`;
    return this.http.get<List<ApplicationMappingDto>>(url);
  }
}
